import { clean } from "../utils/utils";
import api from "./api";
import { ChildSupportPayment } from "../models/ChildSupportPayment";

const PATH = "/api/v1/child-support-payments";

export const ChildSupportPaymentService = {
  async create(
    data: Omit<ChildSupportPayment, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const response = await api.post(PATH, clean(data));
    return response.data.data._id;
  },

  async getAll(): Promise<ChildSupportPayment[]> {
    const response = await api.get(PATH);
    return response.data.data;
  },

  async get(id: string): Promise<ChildSupportPayment> {
    const response = await api.get(`${PATH}/${id}`);
    return response.data.data;
  },

  async update(
    id: string,
    updates: Partial<Omit<ChildSupportPayment, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.patch(`${PATH}/${id}`, clean(updates));
  },

  async delete(id: string): Promise<void> {
    await api.delete(`${PATH}/${id}`);
  },
};
